'use strict';

var Params = function Params(dataLength, wideLabelsMode) {
  return function (containerWidth, containerHeight) {
    var padding = {
      top: 10,
      bottom: 30,
      left: 0,
      right: 0
    };
    var minWidth = 200;
    var barWidth = wideLabelsMode ? 100 : 50;
    var width = dataLength * barWidth;
    width = width > minWidth ? width : minWidth;
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding,
      yAxisShift: padding.right - containerWidth,
      yNumberOfTicks: 5,
      forceWidth: true,
      forceHeight: true
    };
  };
};
module.exports = Params;